'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from 'react';
import { DocumentoPadraoArquivarDialog } from '@/features/documentosPadrao/components/DocumentoPadraoArquivarDialog';
import { DocumentoPadraoDetalhesDrawer } from '@/features/documentosPadrao/components/DocumentoPadraoDetalhesDrawer';
import { DocumentoPadraoExcluirDialog } from '@/features/documentosPadrao/components/DocumentoPadraoExcluirDialog';
import { DocumentoPadraoFormDrawer } from '@/features/documentosPadrao/components/DocumentoPadraoFormDrawer';
import { DocumentosPadraoArquivadosTabela } from '@/features/documentosPadrao/components/DocumentosPadraoArquivadosTabela';
import { DocumentosPadraoComoFuncionaDrawer } from '@/features/documentosPadrao/components/DocumentosPadraoComoFuncionaDrawer';
import { DocumentosPadraoFiltros } from '@/features/documentosPadrao/components/DocumentosPadraoFiltros';
import { DocumentosPadraoTabela } from '@/features/documentosPadrao/components/DocumentosPadraoTabela';
import { useDocumentosPadrao } from '@/features/documentosPadrao/hooks/useDocumentosPadrao';
import { useDocumentosPadraoAcoes } from '@/features/documentosPadrao/hooks/useDocumentosPadraoAcoes';
import type { DocumentoPadrao, DocumentoPadraoFormInput, DocumentosPadraoAba } from '@/features/documentosPadrao/types/documentosPadraoTypes';
import { Button } from '@/shared/components/ui/common/Button';
import { EmptyState } from '@/shared/components/ui/common/EmptyState';
import { ErrorState } from '@/shared/components/ui/common/ErrorState';
import { PageHeader_Main } from '@/shared/components/ui/common/PageHeader_Main';
import { Skeleton } from '@/shared/components/ui/common/Skeleton';
import { TablePagination } from '@/shared/components/ui/common/TablePagination';
import { Tabs } from '@/shared/components/ui/common/Tabs';
import { FeatherBookOpen, FeatherClock, FeatherHelpCircle, FeatherInfo, FeatherPlus, FeatherSearch } from '@subframe/core';
import { DIAS_AVISO_VENCIMENTO_FALLBACK } from '@/features/documentosPadrao/utils/documentosPadraoRegras';
const FORMATOS_ACEITOS = '.pdf,.doc,.docx,.png,.jpg,.jpeg';
export function DocumentosPadraoView() {
  const $ = _c(123);
  const {
    aba,
    abrirDetalhe,
    atualizarFiltros,
    bibliotecaVazia,
    buscandoPartes,
    buscarPartes,
    carregando,
    carregarMaisUsos,
    detalhe,
    diasAviso,
    fecharDetalhe,
    partes,
    contadores,
    contexto,
    erro,
    filtros,
    irParaPagina,
    itensDaPagina,
    limparFiltros,
    pagina,
    recarregar,
    referencia,
    resumo,
    salvando,
    setores,
    temFiltrosAtivos,
    totalPaginas,
    trocarAba,
    verSomenteValidadeCritica
  } = useDocumentosPadrao();
  const acoes = useDocumentosPadraoAcoes();
  const inputSubstituicaoRef = useRef(null);
  const [comoFuncionaAberto, setComoFuncionaAberto] = useState(false);
  const [formAberto, setFormAberto] = useState(false);
  const [documentoEmEdicao, setDocumentoEmEdicao] = useState(null);
  const [documentoParaArquivar, setDocumentoParaArquivar] = useState(null);
  const [documentoParaExcluir, setDocumentoParaExcluir] = useState(null);
  const [documentoParaSubstituir, setDocumentoParaSubstituir] = useState(null);
  const documentoDetalhado = detalhe;
  const mostrarBannerValidade = aba !== "arquivados" && (resumo.vencidos > 0 || resumo.vencendo > 0);
  const listaVazia = !carregando && itensDaPagina.length === 0;
  let t0;
  if ($[0] !== documentoParaExcluir || $[1] !== itensDaPagina) {
    t0 = documentoParaExcluir ? itensDaPagina.find(item => item.id === documentoParaExcluir.id) ?? documentoParaExcluir : null;
    $[0] = documentoParaExcluir;
    $[1] = itensDaPagina;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const documentoParaExcluirAtual = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setDocumentoEmEdicao(null);
      setFormAberto(true);
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleNovoDocumento = t1;
  let t2;
  if ($[4] !== fecharDetalhe) {
    t2 = documento => {
      fecharDetalhe();
      setDocumentoEmEdicao(documento);
      setFormAberto(true);
    };
    $[4] = fecharDetalhe;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleEditar = t2;
  let t3;
  if ($[6] !== acoes || $[7] !== documentoEmEdicao) {
    t3 = async input => {
      const salvo = documentoEmEdicao ? await acoes.atualizar(documentoEmEdicao.id, input, documentoEmEdicao.revisao) : await acoes.criar(input);
      if (salvo) {
        setFormAberto(false);
        setDocumentoEmEdicao(null);
      }
    };
    $[6] = acoes;
    $[7] = documentoEmEdicao;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleSalvarForm = t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = documento_0 => {
      setDocumentoParaSubstituir(documento_0);
      inputSubstituicaoRef.current?.click();
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleSolicitarSubstituicao = t4;
  let t5;
  if ($[10] !== acoes || $[11] !== documentoParaSubstituir) {
    t5 = async evento => {
      const selecionado = evento.target.files?.[0];
      evento.target.value = "";
      if (!selecionado || !documentoParaSubstituir) {
        return;
      }
      await acoes.substituirArquivo(documentoParaSubstituir.id, selecionado);
      setDocumentoParaSubstituir(null);
    };
    $[10] = acoes;
    $[11] = documentoParaSubstituir;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleArquivoSubstituto = t5;
  let t6;
  if ($[13] !== acoes || $[14] !== fecharDetalhe) {
    t6 = async documento_1 => {
      const arquivado = await acoes.arquivar(documento_1);
      if (arquivado) {
        setDocumentoParaArquivar(null);
        setDocumentoParaExcluir(null);
        fecharDetalhe();
      }
    };
    $[13] = acoes;
    $[14] = fecharDetalhe;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const handleConfirmarArquivamento = t6;
  let t7;
  if ($[16] !== acoes || $[17] !== fecharDetalhe) {
    t7 = async documento_2 => {
      const excluido = await acoes.excluir(documento_2);
      if (excluido) {
        setDocumentoParaExcluir(null);
        fecharDetalhe();
      }
    };
    $[16] = acoes;
    $[17] = fecharDetalhe;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleConfirmarExclusao = t7;
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Button variant="neutral-secondary" icon={<FeatherHelpCircle />} onClick={() => setComoFuncionaAberto(true)}>Como funciona</Button>;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <PageHeader_Main title={"Documentos padr\xE3o"} subtitle={"Cadastre uma vez e reutilize em notifica\xE7\xF5es, negocia\xE7\xF5es, media\xE7\xF5es e processos arbitrais"} actions={<div className="flex items-center gap-3">{t8}<Button icon={<FeatherPlus />} onClick={handleNovoDocumento}>Novo documento</Button></div>} />;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== trocarAba) {
    t10 = valor => trocarAba(valor as DocumentosPadraoAba);
    $[21] = trocarAba;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = `Todos · ${contadores.todos}`;
  let t12;
  if ($[23] !== t11) {
    t12 = <Tabs.Item value="todos">{t11}</Tabs.Item>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = `Do escritório · ${contadores.escritorio}`;
  let t14;
  if ($[25] !== t13) {
    t14 = <Tabs.Item value="escritorio">{t13}</Tabs.Item>;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const t15 = `Dos meus setores · ${contadores.meusSetores}`;
  let t16;
  if ($[27] !== t15) {
    t16 = <Tabs.Item value="meus-setores">{t15}</Tabs.Item>;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const t17 = `Pessoais · ${contadores.pessoais}`;
  let t18;
  if ($[29] !== t17) {
    t18 = <Tabs.Item value="pessoais">{t17}</Tabs.Item>;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  const t19 = `Arquivados · ${contadores.arquivados}`;
  let t20;
  if ($[31] !== t19) {
    t20 = <Tabs.Item value="arquivados">{t19}</Tabs.Item>;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== aba || $[34] !== t10 || $[35] !== t12 || $[36] !== t14 || $[37] !== t16 || $[38] !== t18 || $[39] !== t20) {
    t21 = <Tabs value={aba} onValueChange={t10}>{t12}{t14}{t16}{t18}{t20}</Tabs>;
    $[33] = aba;
    $[34] = t10;
    $[35] = t12;
    $[36] = t14;
    $[37] = t16;
    $[38] = t18;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== handleArquivoSubstituto) {
    t22 = <input ref={inputSubstituicaoRef} type="file" accept={FORMATOS_ACEITOS} className="hidden" onChange={handleArquivoSubstituto} />;
    $[41] = handleArquivoSubstituto;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== aba || $[44] !== abrirDetalhe || $[45] !== acoes.baixar || $[46] !== acoes.duplicar || $[47] !== acoes.restaurar || $[48] !== atualizarFiltros || $[49] !== bibliotecaVazia || $[50] !== carregando || $[51] !== diasAviso || $[52] !== erro || $[53] !== filtros || $[54] !== handleEditar || $[55] !== irParaPagina || $[56] !== itensDaPagina || $[57] !== limparFiltros || $[58] !== listaVazia || $[59] !== mostrarBannerValidade || $[60] !== pagina || $[61] !== recarregar || $[62] !== referencia || $[63] !== resumo || $[64] !== setores || $[65] !== temFiltrosAtivos || $[66] !== totalPaginas || $[67] !== verSomenteValidadeCritica) {
    t23 = erro && !carregando ? <ErrorState title={"N\xE3o foi poss\xEDvel carregar a biblioteca"} description={erro} onReset={recarregar} /> : bibliotecaVazia ? <div className="flex w-full flex-col items-center gap-6 rounded-[16px] border border-solid border-neutral-200 bg-white p-12"><EmptyState icon={<FeatherBookOpen />} title={"Nenhum documento padr\xE3o ainda"} description={"Cadastre os documentos que voc\xEA anexa sempre \u2014 procura\xE7\xF5es, carteira da OAB, contratos sociais \u2014 e eles ficam guardados aqui, prontos para reutilizar."} action={<Button icon={<FeatherPlus />} onClick={handleNovoDocumento}>Cadastrar primeiro documento</Button>} /></div> : <div className="flex w-full flex-col overflow-hidden rounded-[16px] border border-solid border-neutral-200 bg-white">{aba === "arquivados" ? <div className="flex items-center gap-2 border-b border-solid border-neutral-100 bg-neutral-50 px-6 py-2.5"><FeatherInfo className="text-subtext-color h-4 w-4 flex-none" /><span className="text-caption font-caption text-subtext-color flex-1">Documentos arquivados não aparecem como sugestão em nenhum produto e não podem ser anexados.</span></div> : <DocumentosPadraoFiltros filtros={filtros} setores={setores} temFiltrosAtivos={temFiltrosAtivos} onAtualizarFiltros={atualizarFiltros} onLimparFiltros={limparFiltros} />}{mostrarBannerValidade && <div className="border-warning-200 bg-warning-50 flex items-center gap-2 border-b border-solid px-6 py-2.5"><FeatherClock className="text-warning-700 h-4 w-4 flex-none" /><span className="text-caption font-caption text-warning-800 flex-1"><strong className="font-semibold">{`${resumo.vencidos} ${resumo.vencidos === 1 ? "documento vencido" : "documentos vencidos"}`}</strong>{` e ${resumo.vencendo} vencendo nos próximos ${diasAviso ?? DIAS_AVISO_VENCIMENTO_FALLBACK} dias. Documentos vencidos não aparecem como sugestão nos produtos.`}</span><Button variant="neutral-secondary" size="small" onClick={verSomenteValidadeCritica}>Ver só esses</Button></div>}{carregando ? <div className="flex w-full flex-col gap-3 p-6"><Skeleton className="h-12 w-full" /><Skeleton className="h-12 w-full" /><Skeleton className="h-12 w-full" /></div> : listaVazia ? <EmptyState className="py-12" icon={<FeatherSearch />} title="Nenhum documento encontrado" description={temFiltrosAtivos ? "Tente ajustar os filtros ou buscar por outro termo." : "Esta aba ainda n\xE3o tem documentos cadastrados."} action={temFiltrosAtivos ? <Button variant="neutral-secondary" onClick={limparFiltros}>Limpar filtros</Button> : undefined} /> : aba === "arquivados" ? <DocumentosPadraoArquivadosTabela itens={itensDaPagina} onVerDetalhes={documento_3 => abrirDetalhe(documento_3.id)} onRestaurar={acoes.restaurar} onExcluir={setDocumentoParaExcluir} /> : <DocumentosPadraoTabela itens={itensDaPagina} setores={setores} referencia={referencia} diasAviso={diasAviso} onVerDetalhes={documento_4 => abrirDetalhe(documento_4.id)} onEditar={handleEditar} onSubstituirArquivo={handleSolicitarSubstituicao} onBaixar={acoes.baixar} onDuplicar={acoes.duplicar} onArquivar={setDocumentoParaArquivar} onExcluir={setDocumentoParaExcluir} />}<TablePagination currentPage={pagina} totalPages={totalPaginas} onPageChange={irParaPagina} /></div>;
    $[43] = aba;
    $[44] = abrirDetalhe;
    $[45] = acoes.baixar;
    $[46] = acoes.duplicar;
    $[47] = acoes.restaurar;
    $[48] = atualizarFiltros;
    $[49] = bibliotecaVazia;
    $[50] = carregando;
    $[51] = diasAviso;
    $[52] = erro;
    $[53] = filtros;
    $[54] = handleEditar;
    $[55] = irParaPagina;
    $[56] = itensDaPagina;
    $[57] = limparFiltros;
    $[58] = listaVazia;
    $[59] = mostrarBannerValidade;
    $[60] = pagina;
    $[61] = recarregar;
    $[62] = referencia;
    $[63] = resumo;
    $[64] = setores;
    $[65] = temFiltrosAtivos;
    $[66] = totalPaginas;
    $[67] = verSomenteValidadeCritica;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  let t24;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = () => setComoFuncionaAberto(false);
    $[69] = t24;
  } else {
    t24 = $[69];
  }
  let t25;
  if ($[70] !== comoFuncionaAberto) {
    t25 = <DocumentosPadraoComoFuncionaDrawer aberto={comoFuncionaAberto} onFechar={t24} />;
    $[70] = comoFuncionaAberto;
    $[71] = t25;
  } else {
    t25 = $[71];
  }
  let t26;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => {
      setFormAberto(false);
      setDocumentoEmEdicao(null);
    };
    $[72] = t26;
  } else {
    t26 = $[72];
  }
  let t27;
  if ($[73] !== buscandoPartes || $[74] !== buscarPartes || $[75] !== contexto || $[76] !== documentoEmEdicao || $[77] !== formAberto || $[78] !== handleSalvarForm || $[79] !== partes || $[80] !== salvando) {
    t27 = <DocumentoPadraoFormDrawer aberto={formAberto} documento={documentoEmEdicao} contexto={contexto} partes={partes} buscandoPartes={buscandoPartes} onBuscarPartes={buscarPartes} salvando={salvando} onFechar={t26} onSalvar={handleSalvarForm} />;
    $[73] = buscandoPartes;
    $[74] = buscarPartes;
    $[75] = contexto;
    $[76] = documentoEmEdicao;
    $[77] = formAberto;
    $[78] = handleSalvarForm;
    $[79] = partes;
    $[80] = salvando;
    $[81] = t27;
  } else {
    t27 = $[81];
  }
  const t28 = Boolean(documentoDetalhado);
  let t29;
  if ($[82] !== acoes) {
    t29 = (documento_5, versao) => acoes.restaurarVersao(documento_5.id, versao);
    $[82] = acoes;
    $[83] = t29;
  } else {
    t29 = $[83];
  }
  let t30;
  if ($[84] !== carregarMaisUsos) {
    t30 = documento_6 => carregarMaisUsos(documento_6.id);
    $[84] = carregarMaisUsos;
    $[85] = t30;
  } else {
    t30 = $[85];
  }
  let t31;
  if ($[86] !== acoes.baixar || $[87] !== acoes.preVisualizar || $[88] !== diasAviso || $[89] !== documentoDetalhado || $[90] !== fecharDetalhe || $[91] !== handleEditar || $[92] !== referencia || $[93] !== setores || $[94] !== t28 || $[95] !== t29 || $[96] !== t30) {
    t31 = <DocumentoPadraoDetalhesDrawer aberto={t28} documento={documentoDetalhado} setores={setores} referencia={referencia} diasAviso={diasAviso} onFechar={fecharDetalhe} onEditar={handleEditar} onSubstituirArquivo={handleSolicitarSubstituicao} onRestaurarVersao={t29} onArquivar={setDocumentoParaArquivar} onExcluir={setDocumentoParaExcluir} onPreVisualizar={acoes.preVisualizar} onCarregarMaisUsos={t30} onBaixar={acoes.baixar} />;
    $[86] = acoes.baixar;
    $[87] = acoes.preVisualizar;
    $[88] = diasAviso;
    $[89] = documentoDetalhado;
    $[90] = fecharDetalhe;
    $[91] = handleEditar;
    $[92] = referencia;
    $[93] = setores;
    $[94] = t28;
    $[95] = t29;
    $[96] = t30;
    $[97] = t31;
  } else {
    t31 = $[97];
  }
  const t32 = Boolean(documentoParaArquivar);
  let t33;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = () => setDocumentoParaArquivar(null);
    $[98] = t33;
  } else {
    t33 = $[98];
  }
  let t34;
  if ($[99] !== documentoParaArquivar || $[100] !== handleConfirmarArquivamento || $[101] !== salvando || $[102] !== t32) {
    t34 = <DocumentoPadraoArquivarDialog aberto={t32} documento={documentoParaArquivar} salvando={salvando} onFechar={t33} onConfirmar={handleConfirmarArquivamento} />;
    $[99] = documentoParaArquivar;
    $[100] = handleConfirmarArquivamento;
    $[101] = salvando;
    $[102] = t32;
    $[103] = t34;
  } else {
    t34 = $[103];
  }
  const t35 = Boolean(documentoParaExcluirAtual);
  let t36;
  if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = () => setDocumentoParaExcluir(null);
    $[104] = t36;
  } else {
    t36 = $[104];
  }
  let t37;
  if ($[105] !== abrirDetalhe) {
    t37 = documento_7 => {
      setDocumentoParaExcluir(null);
      abrirDetalhe(documento_7.id);
    };
    $[105] = abrirDetalhe;
    $[106] = t37;
  } else {
    t37 = $[106];
  }
  let t38;
  if ($[107] !== documentoParaExcluirAtual || $[108] !== handleConfirmarArquivamento || $[109] !== handleConfirmarExclusao || $[110] !== salvando || $[111] !== t35 || $[112] !== t37) {
    t38 = <DocumentoPadraoExcluirDialog aberto={t35} documento={documentoParaExcluirAtual} salvando={salvando} onFechar={t36} onConfirmarExclusao={handleConfirmarExclusao} onArquivar={handleConfirmarArquivamento} onVerUsos={t37} />;
    $[107] = documentoParaExcluirAtual;
    $[108] = handleConfirmarArquivamento;
    $[109] = handleConfirmarExclusao;
    $[110] = salvando;
    $[111] = t35;
    $[112] = t37;
    $[113] = t38;
  } else {
    t38 = $[113];
  }
  let t39;
  if ($[114] !== t21 || $[115] !== t22 || $[116] !== t23 || $[117] !== t25 || $[118] !== t27 || $[119] !== t31 || $[120] !== t34 || $[121] !== t38) {
    t39 = <div className="flex h-full w-full max-w-none flex-col items-start gap-6 p-9">{t9}{t21}{t22}{t23}{t25}{t27}{t31}{t34}{t38}</div>;
    $[114] = t21;
    $[115] = t22;
    $[116] = t23;
    $[117] = t25;
    $[118] = t27;
    $[119] = t31;
    $[120] = t34;
    $[121] = t38;
    $[122] = t39;
  } else {
    t39 = $[122];
  }
  return t39;
}